// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.header-container {
    padding: 1rem 2rem;
    margin-top: 7rem;
    max-width: 100%;
}

.container-transcripts {
    margin-top: 1rem;
    padding: 1rem 3.5rem;
}

`, "",{"version":3,"sources":["webpack://./src/Magor/TranscriptStudio/TranscriptStudio.css"],"names":[],"mappings":";AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;AACxB","sourcesContent":["\n.header-container {\n    padding: 1rem 2rem;\n    margin-top: 7rem;\n    max-width: 100%;\n}\n\n.container-transcripts {\n    margin-top: 1rem;\n    padding: 1rem 3.5rem;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
